import { Box, Typography } from "@mui/material";

type ProfileInformationListItemProps = {
  label: string;
  text: string | number;
};

const ProfileInformationListItem = ({
  label,
  text,
}: ProfileInformationListItemProps) => {
  return (
    <Box sx={{ width: "100%", alignItems: "start", marginBottom: 2 }}>
      <Typography
        variant="caption"
        sx={{ fontWeight: 500, color: "primary.main", fontSize: 16 }}
      >
        {label}
      </Typography>
      <Typography sx={{ fontWeight: 700, color: "text.primary", fontSize: 16 }}>
        {text}
      </Typography>
    </Box>
  );
};

export default ProfileInformationListItem;
